import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyCTA({
  triggerId
}: {
  triggerId: string;
}) {
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    const check = () => {
      const el = document.getElementById(triggerId);
      if (!el) return;
      setVisible(el.getBoundingClientRect().top < window.innerHeight * 0.85);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [triggerId]);
  return <AnimatePresence data-id="element-125" data-mp="297m979vycnwu">
      {visible && <motion.div initial={reduce ? {
      opacity: 0
    } : {
      y: '100%'
    }} animate={reduce ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduce ? {
      opacity: 0
    } : {
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/40 bg-ink/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur md:hidden" data-id="element-126" data-mp="296jh4ymw8ffc">
          <CTAButton data-id="element-127" data-mp="3p3nrw0su3ict" />
        </motion.div>}
    </AnimatePresence>;
}